import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
	L10nTranslationService
} from 'angular-l10n';
import { Observable, throwError as observableThrowError } from 'rxjs';

import { catchError, map, share } from 'rxjs/operators';
import { APIConfigService } from '../../api.config.service';
import { AuthService } from '../../shared/auth.service';
import { ErrorHelper } from '../../shared/error.helper';
import { LoggerService } from '../../shared/logger.service';
import { Kernantwort } from '../../shared/response/kernantwort.model';
import { OaseListe } from './oaseliste.model';
import { RestService } from './rest.service.interface';

const PATH_FILE = 'app/protected/immerdrin/rest.service.impl.ts';

@Injectable()
export class RestServiceImpl implements RestService {
	isRequestRunning = false;
	fehler: Kernantwort = null;
	apiUrlPrefix: string = null;
	apiUrlListId: string = null;

	API_LIST = 'liste';
	API_CREATE = 'hinzufuegen';
	API_UPDATE = 'bearbeiten';
	API_DELETE = 'loeschen';

	constructor(
		public authService: AuthService,
		public http: HttpClient,
		public translation: L10nTranslationService,
		public apiConfigService: APIConfigService,
		public _logger: LoggerService
	) {
		this.init();
	}

	init() {
		this.isRequestRunning = false;
		this.fehler = null;
	}

	liste(page: number, size: number, sort: string, sortdirection: string, search: string, extra: string): Observable<OaseListe<any>> {
	// liste(page: number, size: number, sort: string, sortdirection: string, search: string): Observable<OaseListe<any>> {
		this.isRequestRunning = true;
		this.fehler = null;
		let query = '';
		if (page) {
			query += (query.length === 0 ? '?' : '&') + 'page=' + page;
		}
		if (size) {
			query += (query.length === 0 ? '?' : '&') + 'size=' + size;
		}
		if (search) {
			query += (query.length === 0 ? '?' : '&') + 'search=' + search;
		}
		if (sort) {
			query += (query.length === 0 ? '?' : '&') + 'sort=' + sort;
			if (sortdirection) {
				query += ',' + sortdirection;
			}
		}
		if(extra)  query += (query.length == 0 ? "?" : "&") + extra;

		let listId = '';
		if (this.apiUrlListId && this.apiUrlListId.length > 0) {
			listId = '/' + this.apiUrlListId;
		}

		return this.http
			.get<OaseListe<any>>(this.getApiUrl() + this.API_LIST + listId + query).pipe(
				share(), // Um mehrfachaufrufe zu verhindern
				map(response => {
					this.isRequestRunning = false;
					return response;
				}),
				catchError(error => {
					this.isRequestRunning = false;
					this.fehler = ErrorHelper.handleError(error, 'Fehler beim laden der Liste', this._logger, this.translation);
					return observableThrowError(this.fehler.message);
				})
			);
	}

	speichernAendern(element: any): Observable<any> {
		this.isRequestRunning = true;
		this.fehler = null;

		let requestUrl = this.getApiUrl() + (element.id ? this.API_UPDATE +'/'+ element.id : this.API_CREATE + '/0');
		this._logger.log(PATH_FILE + ' - speichernAendern - requestUrl: ' + requestUrl);

		return this.http
			.put<any>(requestUrl, JSON.stringify(element), {
				headers: new HttpHeaders({ 'Content-Type': 'application/json' })
			}).pipe(
				share(), // Um mehrfachaufrufe zu verhindern
				map(response => {
					this._logger.log(PATH_FILE + ' - speichernAendern response:', response);
					this.isRequestRunning = false;
					return response;
				}),
				catchError(error => {
					this._logger.log(PATH_FILE + ' - speichernAendern error:', error);
					this.isRequestRunning = false;
					this.fehler = ErrorHelper.handleError(error, 'Fehler beim speichern (' + (element.id ? 'hinzufuegen' : 'bearbeiten') + ')', this._logger, this.translation);
					return observableThrowError(this.fehler.message);
				})
			);
	}

	loeschen(id: number): Observable<any> {
		this.isRequestRunning = true;
		this.fehler = null;
		return this.http
			.delete<any>(this.getApiUrl() + this.API_DELETE + '/' + id, {
				headers: new HttpHeaders({ 'Content-Type': 'application/json' })
			}).pipe(
				share(), // Um mehrfachaufrufe zu verhindern
				map(response => {
					this._logger.log(PATH_FILE + ' - loeschen response:', response);
					this.isRequestRunning = false;
					return response;
				}),
				catchError(error => {
					this._logger.log(PATH_FILE + ' - loeschen error:', error);
					this.isRequestRunning = false;
					this.fehler = ErrorHelper.handleError(error, 'Fehler beim löschen', this._logger, this.translation);
					this._logger.log(PATH_FILE + ' - loeschen fehler:', this.fehler);
					return observableThrowError(this.fehler.message);
				})
			);
	}

	getApiBaseUrl(): string {
		return this.apiConfigService.REST_API_BASE();
	}

	getApiUrl(): string {
		this._logger.log(PATH_FILE + ' - getApiUrl this.apiUrlPrefix:' + this.apiUrlPrefix);
		return this.getApiBaseUrl() + this.apiUrlPrefix+'/';
	}
}